import { FC } from "react";
import Script from "next/script";
import { InstagramWrapper } from "./Instagram.styled";
interface Props {
  url?: string;
}

const Instagram: FC<Props> = ({ url }) => {
  return (
    <>
      <Script async defer src="https://www.instagram.com/embed.js" />

      <InstagramWrapper>
        <blockquote
          className="instagram-media"
          data-instgrm-captioned
          data-instgrm-permalink={`${url}/?utm_source=ig_embed&amp;utm_campaign=loading`}
          data-instgrm-version="14"
          style={{ minWidth: "100%" }}
        >
          <a
            href={`${url}/?utm_source=ig_embed&amp;utm_campaign=loading`}
            target="_blank"
            rel="noreferrer"
          ></a>
        </blockquote>
      </InstagramWrapper>
    </>
  );
};

export default Instagram;
